import React from "react";
import Star from "@/shared/media/icons/policy/trustpilot-star.svg";

const Stars = ({ stars }: { stars: number }) => {
    return (
        <div className="Stars flex items-center gap-[1.33px]">
            {Array(stars)
                .fill(0)
                .map((_, index) => (
                    <Star key={`star-${index}`} />
                ))}
        </div>
    );
};

export default Stars;
